/**
 * Centralized network timeout configuration.
 * Byte-port of BigxBookApp/src/config/timeouts.ts.
 */
export const DEFAULT_FETCH_TIMEOUT_MS = 15_000;
export const SYNC_PULL_TIMEOUT_MS = 45_000;
export const SYNC_PUSH_TIMEOUT_MS = 30_000;
export const AUTH_FETCH_TIMEOUT_MS = 45_000;
export const DEVICE_IDENTITY_TIMEOUT_MS = 10_000;
export const DEVICE_SLOT_TIMEOUT_MS = 5_000;
